import { EInvoiceConfigurationCode } from "@/@core/data/enum/menuCode";
import { mapGetters, mapState } from 'vuex';


export default {
  data() {
    return {
     
    }
  },
  async created() {
  
  },
  computed: {
     ...mapGetters({
          $ls_CurrentSiteID: 'auth/currentSiteID',
          $lsAllowOperation: 'app/allowOperation',
        }),
   
  },
  methods: {
   isCanEditEInvoiceConfiguration() {    
        return this.$lsAllowOperation(EInvoiceConfigurationCode.EDIT);
    }

  },
}
